<template>
  <div class="fixWidth container-fluid">
    <v-dialog v-model="formDialogStatus" max-width="1000px" persistent>
      <formDialog
        :dialogStatus.sync="formDialogStatus"
        :editedData="editedItem"
        :indexEdited.sync="editedIndex"
        @callReget="
          (val) => {
            if (val) {
              this.pagination.page = 1;
            }
            this.searchFaq();
          }
        "
      ></formDialog>
    </v-dialog>
    <v-dialog v-model="deleteDialogStatus" max-width="600px">
      <deleteDialog
        v-on:changeTitle="updateTitleData($event)"
        v-on:changeStat="closeDelDialog($event)"
      ></deleteDialog>
    </v-dialog>
    <v-dialog v-model="detailsDialogStatus">
      <faqDetails
        :parentData="currentParentItem"
        @blogCommentReplyStatus="commentCloser"
      >
      </faqDetails>
    </v-dialog>
    <snackbar :snacksProp="snackBar" />
    <template>
      <v-expansion-panels focusable>
        <v-expansion-panel class="mb-3">
          <v-expansion-panel-header
            >Custom Search Panel</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-container class="fixWidth">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    label="Question"
                    v-model="searchParam.question"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-layout justify-center>
                <div>
                  <v-btn
                    color="red"
                    style="margin-left"
                    @click.stop.prevent="clear()"
                    >Clear</v-btn
                  >
                </div>
                <div style="width: 20px"></div>
                <div>
                  <v-btn
                    color="primary  white--text"
                    @click.stop.prevent="searchFaq()"
                    >Search</v-btn
                  >
                </div>
                <span></span>
              </v-layout>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>

    <v-data-table
      :headers="headers"
      :items="getFaqItem"
      :server-items-length="totalItems"
      :options.sync="pagination"
      :footer-props="pagination.rowsPerPageItems"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>FAQ List</v-toolbar-title>
          <!-- {{getErrorMessage.message}} -->
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            @click="newItem"
            v-if="functionalAccess.add == '1'"
            >Create New FAQ
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.id="{ item, index }">
        {{ index + (pagination.page - 1) * pagination.itemsPerPage + 1 }}
      </template>
      <template v-slot:item.answer="{ item }">
        <div v-html="item.answer"></div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attr }">
            <v-icon
              size="25px"
              class="mr-2"
              color="primary"
              v-on="on"
              v-bind="attr"
              v-if="functionalAccess.edit == '1'"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>EDIT</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attr }">
            <v-icon
              size="25px"
              color="red"
              v-on="on"
              v-bind="attr"
              v-if="functionalAccess.delete == '1'"
              @click="deleteDialogOpen(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>DELETE</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data> No data available </template>
    </v-data-table>
  </div>
</template>
<script>
import formDialog from "@/components/faq/faq.vue";
import deleteDialog from "@/components/utils/deleteDialog.vue";
import snackbar from "@/components/utils/snackbar.vue";
import faqDetails from "@/components/faq/faqDetails.vue";
import functionalMixin from "../../mixins/searchFunction";
import clearSearch from "@/mixins/clearSearch";

export default {
  components: {
    formDialog,
    deleteDialog,
    snackbar,
    faqDetails,
  },
  mixins: [functionalMixin, clearSearch],
  data() {
    return {
      pagination: {
        itemsPerPage: 10,
        rowsPerPageItems: { "items-per-page-options": [5, 10, 25, 100, 200] },
      },
      snackbarMessage: "",
      totalItems: null,
      searchString: "",
      editedItem: {},

      editedIndex: -1,
      loading: false,
      title: "tiiii",
      dialog: false,
      formDialogStatus: false,
      deleteDialogStatus: false,
      deleteId: {},
      currentItem: {},
      divisionList: [],
      searchString: "",
      searchParam: {},
      detailsDialogStatus: false,
      currentParentItem: null,
      snackBar: {
        control: false,

        multiline: true,
        text: {
          message: "",
        },
      },

      headers: [
        { text: "Serial No.", value: "id", sortable: false },
        { text: "Order No", value: "order_no", sortable: false },
        { text: "Question", value: "question", sortable: false },
        { text: "Answer", value: "answer", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  created() {
    // this.$store.dispatch("callFaqData");
    // this.searchDistrict();
  },
  mounted() {
    // this.$validator.localize("en", this.dictionary);
  },
  computed: {
    getFaqItem() {
      return this.$store.getters.getFaqItem;
    },
    getLoggedInStatus() {
      return this.$store.getters.getLoggedIn;
    },
    getTitle() {
      return this.title;
    },
    getResponseMessage() {
      return this.$store.getters.getResponseMessage;
    },
    getErrorMessage(state) {
      return this.$store.getters.getErrorMessage;
    },
  },
  watch: {
    getTitle(val) {
      if (val == "confirmed") {
        this.deleteItem();
      }
    },
    pagination() {
      this.searchFaq();
    },
    getResponseMessage(val) {
      this.snackBar.text.message = val.message;
      this.snackBar.control = true;
    },
    getErrorMessage(val) {
     //  console.log("val asada", val.message);
      let myObject = val.message;
      for (const [key, value] of Object.entries(myObject)) {
        this.snackBar.text.message = value[0];
        this.snackBar.control = true;
      }
    },
  },

  methods: {
    commentCloser() {
      this.searchFaq();
      this.detailsDialogStatus = false;
    },

    searchFaq() {
      this.loading = true;
      this.searchString = "";
      if (this.searchParam.answer) {
        if (this.searchString == "") {
          this.searchString = `answer like '%${this.searchParam.answer}%'`;
        } else {
          this.searchString = `${this.searchString} and answer like '%${this.searchParam.answer}%'`;
        }
      }
      if (this.searchParam.question) {
        if (this.searchString == "") {
          this.searchString = `question like '%${this.searchParam.question}%'`;
        } else {
          this.searchString = `${this.searchString} and question like '%${this.searchParam.question}%'`;
        }
      }
      encodeURIComponent(this.searchString);
      this.$store
        .dispatch("callFaqData", {
          page: this.pagination.page,
          size: this.pagination.itemsPerPage,
          search: this.searchString,
        })
        .then((data) => {
          this.loading = false;
          this.totalItems = data.total;
        });
    },

    dialogOpen() {
      this.formDialogStatus = true;
    },
    closeDelDialog(deleteDialogStatus) {
      this.deleteDialogStatus = false;
    },
    updateTitleData(title) {
      this.title = title;
    },
    newItem() {
      this.dialogOpen();
    },
    editItem(item) {
      this.editedIndex = this.getFaqItem.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$store.commit("SET_FAQ_SCHEMA", this.editedItem);
      this.dialogOpen();
    },
    deleteDialogOpen(item) {
      this.deleteId = item.id;
      this.deleteDialogStatus = true;
    },
    async deleteItem() {
      let self = this;
      await this.$store
        .dispatch("deleteFaqItem", this.deleteId)
        .then(function (data) {
          try {
            this.title = "";
            this.deleteDialogStatus = false;
            self.searchFaq();
            // self.$store.dispatch("callFaqData");
          } catch (ex) {
           //  console.log(ex);
          }
        })
        .catch(function (error) {
         //  console.log(error);
        });
    },
    showDescription(item) {
      this.currentParentItem = item;
      this.detailsDialogStatus = true;
    },
  },
};
</script>
<style>
.v-data-table th {
  font-size: 14px !important;
}
.fixWidth {
  width: auto;
}
</style>
